import { reducer as entity } from './Entity';
import { reducer as account } from './Account';

export default {
  account,
  entity
};
